/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Shorts use the same thumbnail system as regular videos, so pasting a /shorts/ link works just like a normal video URL.`)
};

const es_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Los Shorts usan el mismo sistema de miniaturas que los videos normales, así que pegar un enlace /shorts/ funciona igual que una URL de video normal.`)
};

const de_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Shorts nutzen dasselbe Thumbnail-System wie normale Videos, daher funktioniert das Einfügen eines /shorts/-Links genauso wie eine normale Video-URL.`)
};

const nl_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Shorts gebruiken hetzelfde thumbnailsysteem als gewone video's, dus het plakken van een /shorts/-link werkt net als een normale video-URL.`)
};

const fr_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les Shorts utilisent le même système de miniatures que les vidéos classiques, donc coller un lien /shorts/ fonctionne exactement comme une URL de vidéo normale.`)
};

const it_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Gli Shorts usano lo stesso sistema di miniature dei video normali, quindi incollare un link /shorts/ funziona esattamente come un URL video normale.`)
};

const pt_br2_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os Shorts usam o mesmo sistema de thumbnail dos vídeos comuns, então colar um link /shorts/ funciona igual a uma URL de vídeo normal.`)
};

const pt_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os Shorts usam o mesmo sistema de miniaturas dos vídeos normais, por isso colar um link /shorts/ funciona tal como um URL de vídeo normal.`)
};

const ja_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。Shortsは通常の動画と同じサムネイルシステムを使用しているため、/shorts/のリンクを貼り付ければ通常の動画URLと同じように機能します。`)
};

const zh_yt_shorts_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。Shorts 使用与普通视频相同的缩略图系统，因此粘贴 /shorts/ 链接的效果与普通视频链接相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq1_a", locale)
	if (locale === "en") return en_yt_shorts_faq1_a(inputs)
	if (locale === "es") return es_yt_shorts_faq1_a(inputs)
	if (locale === "de") return de_yt_shorts_faq1_a(inputs)
	if (locale === "nl") return nl_yt_shorts_faq1_a(inputs)
	if (locale === "fr") return fr_yt_shorts_faq1_a(inputs)
	if (locale === "it") return it_yt_shorts_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq1_a(inputs)
	if (locale === "pt") return pt_yt_shorts_faq1_a(inputs)
	if (locale === "ja") return ja_yt_shorts_faq1_a(inputs)
	return zh_yt_shorts_faq1_a(inputs)
};